<div class="psa-customization-form">
  <!-- Error message -->
  @if(metadataError) {
  <app-status-banner
    variant="detailed"
    type="warning"
    [body]="metadataError"
    title="PSA Data Error">
  </app-status-banner>
  }

  <!-- Loading message -->
  @if(showLoading && isLoadingMetadata) {
  <app-status-banner
    variant="basic"
    type="info"
    [showSpinner]="true"
    message="Loading PSA configuration options. This can take a few seconds…"
  >
  </app-status-banner>
  }

  <!-- Formly Form with a heading row that carries the refresh action -->
  <div autocomplete="off" data-lpignore="true" data-form-type="other" class="psa-form-container">
    <!-- Heading row: optional section title on the left, refresh action on the right. Its
         position is tied to the section heading rather than to a specific field, so it stays put
         regardless of which dropdowns a PSA renders (e.g. Syncro hides board/source/priority). -->
    @if(ticketSectionTitle || (showRefreshButton && connector)) {
    <div class="psa-section-heading" [class.has-title]="!!ticketSectionTitle">
      @if(ticketSectionTitle) {
      <h6 class="psa-section-heading__title">{{ ticketSectionTitle }}</h6>
      }
      @if(showRefreshButton && connector) {
      <button
        type="button"
        class="psa-refresh-btn"
        (click)="reloadMetadata()"
        [disabled]="isLoadingMetadata"
        [attr.aria-label]="'Refresh options from ' + (psaName || 'the PSA')"
        [title]="'Reload options from ' + (psaName || 'the PSA')"
      >
        <i class="fa fa-refresh" [class.fa-spin]="isLoadingMetadata"></i>
        <span>{{ isLoadingMetadata ? 'Refreshing…' : 'Refresh options' }}</span>
      </button>
      }
    </div>
    }

    <formly-form
      [form]="form"
      [fields]="formFields"
      [model]="formModel"
    ></formly-form>
  </div>
</div>
